const constants = {
  backendUrl: "https://api.gutgereift.at/wp/graphql",
  nexusLandscapeWidth: 1024,
  nexusPortraitWidth: 768,
  iPhoneLandscapeWidth: 667,
  iPhonePortraitWidth: 420,
};

export default constants;
